import { TabPanel, TabView, TabViewTabChangeEvent } from 'primereact/tabview';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import styles from './CertificatesTabView.module.css';
import MyCertificatesTab from './tabs/my-certificates-tab/MyCertificatesTab';
import SupplierCertificatesTab from './tabs/supplier-certificates-tab/SupplierCertificatesTab';

const TABS = ['my-certificates', 'supplier-certificates'];

const CertificatesTabView = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const activeTabIndex = useMemo(() => {
    const pathSegments = location.pathname.split('/').filter(Boolean);
    const activeTab = pathSegments[1];

    return Math.max(TABS.indexOf(activeTab), 0);
  }, [location.pathname]);

  const handleTabChange = (event: TabViewTabChangeEvent) => {
    const href = `/certificates/${TABS[event.index]}`;
    navigate(href);
  };

  return (
    <TabView
      className={styles['certificates-tab-view']}
      pt={{
        nav: { className: 'flex flex-row gap-6' },
      }}
      activeIndex={activeTabIndex}
      onTabChange={handleTabChange}
    >
      <TabPanel header={t('certificatesPage.tabs.myCertificatesTab.tabHeader')}>
        <MyCertificatesTab />
      </TabPanel>

      <TabPanel header={t('certificatesPage.tabs.supplierCertificatesTab.tabHeader')}>
        <SupplierCertificatesTab />
      </TabPanel>
    </TabView>
  );
};

export default CertificatesTabView;
